import { asNoyauColorToken, noyauAccentStyle } from '@/lib/display-tweaks';
import { FAKE_COMPANY } from './fake-company';
import { PreviewFrame } from './preview-frame';
import type { SettingPreviewProps } from './setting-preview-props';

/**
 * `matrix-noyaux-accent`: a company page header (title, tabs, button) under the
 * same custom-property override the real accent scope applies.
 */
export function NoyauAccentPreview({ value }: SettingPreviewProps) {
  return (
    <PreviewFrame>
      <div style={noyauAccentStyle(asNoyauColorToken(value))} className="px-6 pt-4 pb-6">
        <div className="mb-2 font-bold text-bleu-nuit text-h3 leading-tight">
          {FAKE_COMPANY.name}
        </div>
        <div className="mb-4 flex gap-4 border-gray-200 border-b font-semibold text-body-lg text-gray-500">
          <span className="-mb-px border-bleu-nuit border-b-2 pb-1 text-bleu-nuit">Matrices</span>
          <span className="pb-1">Paramètres</span>
        </div>
        <span className="inline-block rounded bg-bleu-nuit px-4 py-1 font-bold text-body-lg text-white">
          Nouvelle matrice
        </span>
      </div>
    </PreviewFrame>
  );
}
